<template>
  <div
    v-if="active"
    class="fixed z-40 inset-0 overflow-y-auto"
  >
    <div
      class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div
        class="fixed inset-0 transition-opacity"
        @click="close()"
      >
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
      <div
        id="modal"
        class="w-full add-ons modal-extra-large inline-block align-bottom rounded-sm text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg"
        :class="step + ' ' + 'tile-' + tilesize"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <modal-close @close="close()" />

        <div class="modal-content">
          <div class="sm:flex sm:items-start">
            <div class="modal-title px-1 mt-3 text-center sm:mt-0 sm:text-left">
              <h3
                class="leading-6 font-bold text-2xl"
                id="modal-headline"
              >
                {{ item.attributes.webshop_description }}
              </h3>
            </div>
          </div>

          <div class="overflow-y-auto overflow-x-hidden flex-grow content-wrapper">
            <!-- Addons -->
            <div
                class="mb-5"
                v-for="(addon, addon_index) in addons"
                :key="addon_index"
                :class="addon.type + '-view'"
              >
                <div class="font-bold flex justify-between mb-3 addon-title">
                  <div>
                    {{ addon.description }}
                    <span v-if="addon.quantity_min > 0">*</span>
                  </div>

                  <div
                    v-if="maxesString && addon.type === 'tiles'"
                    class="text-red-600 text-xs"
                  >
                    {{ maxesString }}
                  </div>

                  <!-- <div>{{ option.description }} ({{ option.price }})</div> -->
                  <div
                    class="text-xs text-red-600"
                    v-if="addon.error"
                  >
                    {{ $t("translations.components.item.select") }}
                    <span v-if="addon.quantity_min && addon.quantity_max"
                      >{{ $t("translations.components.item.minimal") }} {{ addon.quantity_min }} en
                      {{ $t("translations.components.item.maximal") }}
                      {{ addon.quantity_max }}</span
                    >
                    <span v-else-if="addon.quantity_min"
                      >{{ $t("translations.components.item.minimal") }}
                      {{ addon.quantity_min }}</span
                    >
                    <span v-else-if="addon.quantity_max"
                      >{{ $t("translations.components.item.maximal") }}
                      {{ addon.quantity_max }}</span
                    >
                  </div>
                  <!-- <span class="text-xs text-red-600" v-if="hasError('addons', addon.description)">verplicht</span> -->
                </div>
                <div class="addon-flexer">
                  <div
                    class="addons"
                    v-for="(option, option_index) in addon.options"
                    :key="option_index"
                  >
                    <!-- Quantity -->
                    <div
                      v-if="addon.type === 'buttons'"
                      class="flex justify-start items-center"
                    >
                      <div class="flex rounded-sm items-center justify-end mr-5">
                        <div class="">
                          <a
                            @click="changeAddonQuantity(option, -1)"
                            class="block rounded-sm p-1 order-action minus"
                          >
                            <svg
                              class="h-6 w-5"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M3 10C3 9.44772 3.44772 9 4 9L16 9C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11L4 11C3.44772 11 3 10.5523 3 10Z"
                              />
                            </svg>
                          </a>
                        </div>

                        <div class="px-5 font-bold">
                          {{ parseInt(option.quantity) }}
                        </div>

                        <div>
                          <a
                            @click="changeAddonQuantity(option, 1)"
                            class="block rounded-sm p-1 order-action plus"
                          >
                            <svg
                              class="h-6 w-6"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10 5C10.5523 5 11 5.44772 11 6V9L14 9C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11H11V14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14V11H6C5.44772 11 5 10.5523 5 10C5 9.44771 5.44772 9 6 9L9 9V6C9 5.44772 9.44771 5 10 5Z"
                              />
                            </svg>
                          </a>
                        </div>
                      </div>
                      <div class="flex justify-between items-center w-full">
                        <div>
                          <div>{{ option.description }} ({{ option.price }})</div>
                          <div
                            class="text-xs text-red-600"
                            v-if="option.error"
                          >
                            <span v-if="option.quantity_min && option.quantity_max"
                              >{{ $t("translations.components.item.minimal") }}
                              {{ option.quantity_min }} en
                              {{ $t("translations.components.item.maximal") }}
                              {{ option.quantity_max }}</span
                            >
                            <span v-else-if="option.quantity_min"
                              >{{ $t("translations.components.item.minimal") }}
                              {{ option.quantity_min }}</span
                            >
                            <span v-else-if="option.quantity_max"
                              >{{ $t("translations.components.item.maximal") }}
                              {{ option.quantity_max }}</span
                            >
                          </div>
                        </div>
                        <div><currency />{{ vueNumberFormat(option.quantity * option.price) }}</div>
                      </div>
                    </div>

                    <!-- Radio -->
                    <div
                      v-if="addon.type === 'radio'"
                      class="flex justify-between items-center"
                    >
                      <div class="flex items-center justify-start gap-5">
                        <input
                          @change="addonRadioSelect(addon, option)"
                          type="radio"
                          :id="option.id"
                          :name="addon.id"
                          :value="option.id"
                        />
                        <label :for="option.id"
                          >{{ option.description }} ({{ option.price }})</label
                        >
                      </div>
                      <div v-if="option.quantity > 0">
                        <currency />
                        {{ vueNumberFormat(option.quantity * option.price) }}
                      </div>
                    </div>

                    <!--Tiles-->

                    <!-- {{option}} -->

                    <!-- {{addon}} -->

                    <a
                      v-if="addon.type === 'tiles'"
                      class="tiles"
                    >
                      <div
                        class="tile relative item border tile-medium select-none"
                        :style="{ 'border-color': option.pos_color || this.parentcolor }"
                        :class="{ active: option.quantity > 0 }"
                      >
                        <span
                          class="inner"
                          @click="
                            processMinMaxAddon(option, 1, [
                              option.quantity,
                              option.quantity_max,
                              addon.quantity_max,
                            ])
                          "
                        ></span>

                        <span class="item-price">{{ vueNumberFormat(option.price) }}</span>

                        <span class="name">{{ option.description }}</span>
                        <span
                          class="quantity item-counter"
                          v-if="option.quantity"
                        >
                          {{ option.quantity }}
                        </span>
                        <span
                          class="minus"
                          v-if="option.quantity"
                          @click="processMinMaxAddon(option, -1)"
                        >
                          -
                        </span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
          </div>
        </div>

          <div class="modal-footer px-4 py-4 sm:px-6 sm:flex sm:justify-between items-center">
            <!-- Quantity -->
            <div>
              <div
                v-if="item?.attributes?.quantity_fixed === false"
                class="flex rounded-sm sm:mb-0 mb-3 items-center justify-center sm:justify-end"
              >
              <div class="">
                <a
                  @click="subQuantity()"
                  class="block rounded-sm border border-gray-200 p-1 order-action minus"
                >
                  <svg
                    class="h-5 w-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3 10C3 9.44772 3.44772 9 4 9L16 9C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11L4 11C3.44772 11 3 10.5523 3 10Z"
                    />
                  </svg>
                </a>
              </div>
              <div class="text-main px-5">
                {{ quantity }}
              </div>
              <div>
                <a
                  @click="addQuantity()"
                  class="block rounded-sm border border-gray-200 p-1 order-action plus"
                >
                  <svg
                    class="h-5 w-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10 5C10.5523 5 11 5.44772 11 6V9L14 9C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11H11V14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14V11H6C5.44772 11 5 10.5523 5 10C5 9.44771 5.44772 9 6 9L9 9V6C9 5.44772 9.44771 5 10 5Z"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div class="sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-sm shadow-sm sm:ml-3 sm:w-auto">
              <a
                @click="confirmAddons()"
                class="button button-filled button-large"
              >
                {{ $t("translations.components.item.confirm") }}
              </a>
            </span>
          </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from "axios"
import ModalClose from "./ModalClose"

export default {
  name: "ModalAddons",
  components: {
    ModalClose,
  },
  emits: ["updated"],
  data() {
    return {
      active: false,
      item: null,
      originalLine: null,
      addons: [],
      quantity: 1,
      loading: false,
      tilesize: "medium",
      step: "addons",
      parentcolor: "#02A388",
      maxesString: "",
      errors: {
        addons: [],
      },
    }
  },

  methods: {
    open(line, item) {
      this.originalLine = line
      this.quantity = line.quantity
      this.item = item
      this.active = true

      this.addons = JSON.parse(
        JSON.stringify(
          this.item.attributes.addons.filter((addon) => addon.pos_active == 1)
        )
      )

      this.preSelectAddons()
    },

    preSelectAddons() {
      const transactionLines = this.$store.getters["transaction/transaction"].lines

      const addonLines = transactionLines.filter(
        (line) => line.parent_id === this.originalLine.id && line.addon
      )

      this.addons.forEach((addonGroup) => {
        addonGroup.options.forEach((option) => {
          option.quantity = 0
          option.quantity_init = 0

          const existingAddon = addonLines.find(
            (line) => line.item_id === option.item_id
          )
          if (existingAddon) {
            option.quantity = existingAddon.quantity
            option.quantity_init = existingAddon.quantity / this.originalLine.quantity
          }
        })
      })
    },

    close() {
      this.active = false
      this.item = null
      this.originalLine = null
      this.addons = []
      this.quantity = 1
      this.errors = { addons: [] }
    },

    addQuantity() {
      this.quantity = this.quantity + 1

      this.addons.forEach((addon) => {
        addon.options.forEach((option) => {
          if (option.quantity > 0) {
            option.quantity =
              parseFloat(option.quantity) +
              parseFloat(option.quantity_init ? option.quantity_init : 1)
          }
        })
      })
    },

    subQuantity() {
      if (this.quantity > 1) {
        this.quantity = this.quantity - 1

        this.addons.forEach((addon) => {
          addon.options.forEach((option) => {
            if (option.quantity > 0) {
              option.quantity =
                parseFloat(option.quantity) -
                parseFloat(option.quantity_init ? option.quantity_init : 1)
            }
          })
        })
      }
    },

    changeAddonQuantity(addon, quantity) {
      if (addon.quantity + quantity < 0) {
        return
      }

      addon.quantity = parseFloat(addon.quantity) + quantity
      addon.quantity_init = addon.quantity / this.quantity
    },

    addonRadioSelect(addon, option) {
      addon.options.forEach((addonOption) => {
        if (option.id === addonOption.id) {
          addonOption.quantity = this.quantity
          addonOption.quantity_init = 1
        } else {
          addonOption.quantity = 0
          addonOption.quantity_init = 0
        }
      })
    },

    processMinMaxAddon(option, increment, maxValues) {
      if (increment > 0) {
        let canAdd = true

        if (maxValues) {
          const [currentQty, optionMax, groupMax] = maxValues

          if (optionMax && currentQty >= optionMax) {
            canAdd = false
            this.maxesString = "Maximum bereikt"
          }

          if (groupMax) {
            const groupTotal = this.addons
              .flatMap((a) => a.options)
              .reduce((sum, opt) => sum + (opt.quantity || 0), 0)
            if (groupTotal >= groupMax) {
              canAdd = false
              this.maxesString = "Maximum bereikt"
            }
          }
        }

        if (canAdd) {
          this.changeAddonQuantity(option, increment)
          this.maxesString = ""
        }
      } else {
        this.changeAddonQuantity(option, increment)
        this.maxesString = ""
      }
    },

    confirmAddons() {
      let addons = []
      let quantityError = false

      this.errors.addons = []

      this.addons.forEach((addonGroup) => {
        let quantity = 0

        addonGroup.options.forEach((addon) => {
          addon.error = false

          if (addon.quantity > 0) {
            quantity += parseFloat(addon.quantity)
            addons.push(addon)
          }

          if (
            (addon.quantity_min && addon.quantity < addon.quantity_min) ||
            (addon.quantity_max && addon.quantity > addon.quantity_max)
          ) {
            addon.error = quantityError = true
          }
        })

        if (
          (addonGroup.quantity_min && quantity < addonGroup.quantity_min) ||
          (addonGroup.quantity_max && quantity > addonGroup.quantity_max)
        ) {
          addonGroup.error = quantityError = true
        }
      })

      if (this.errors.addons.length > 0 || quantityError === true) {
        return
      }

      this.updateTransaction(addons)
    },

    updateTransaction(addons) {
      const updatedLine = {
        ...this.originalLine,
        quantity: this.quantity,
      }

      const updatedAddons = addons.map((addon) => ({
        parent_id: updatedLine.id,
        item_id: addon.item_id,
        item_parent_id: this.item.id,
        addon: true,
        editable: true,
        barcode: addon.barcode,
        description: addon.description,
        thumbnail: null,
        taxrate: addon.taxrate,
        rate: addon.price ? addon.price : 0,
        rate_without_discount: addon.price ? addon.price : 0,
        discount_amount: 0,
        kitchen_groceries: [],
        quantity: parseInt(addon.quantity),
      }))

      this.$store.dispatch("transaction/updateLineWithAddons", {
        line: updatedLine,
        addons: updatedAddons,
      })

      this.$emit("updated")
      this.close()
    },
  },
}
</script>
